import { Input } from '@ophelos/ui/components/input';
import { Mail } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

/** Pragmatic email shape check — the server re-validates and is the source of truth. */
const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const isValidPayerEmail = (email: string) => EMAIL_PATTERN.test(email.trim());

interface PayerEmailFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
}

/** Collects a payer email in-flow when the customer has none on file, so payment confirmations and receipts can be sent. */
export function PayerEmailField({ id, value, onChange }: PayerEmailFieldProps) {
  const { t } = useTranslation();
  const valid = isValidPayerEmail(value);

  return (
    <div className="max-w-sm mx-auto w-full space-y-2">
      <label htmlFor={id} className="text-sm font-medium text-muted-foreground">
        {t('paymentPlan.emailLabel')} <span className="text-destructive">*</span>
      </label>
      <div className="relative">
        <Mail className="absolute left-4 top-1/2 -translate-y-1/2 size-4 opacity-25" />
        <Input
          id={id}
          type="email"
          size="lg"
          required
          aria-required="true"
          placeholder={t('paymentPlan.emailPlaceholder')}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="pl-11"
          autoComplete="email"
          aria-invalid={value.length > 0 && !valid}
        />
      </div>
      <p className="text-xs text-muted-foreground">{t('paymentPlan.emailHelp')}</p>
    </div>
  );
}
